<template>
  <div class="box-wrapper">
    <slot />
  </div>
</template>

<style scoped>
.box-wrapper {
  @apply p-3 border border-slate-200 dark:border-zinc-700 bg-slate-50 dark:bg-zinc-800 rounded-10;
}
</style>
